import {useSearchParams, useNavigate} from 'react-router-dom'
import {useEffect} from 'react'

const LoginErrorCallback = () => {
    const [searchParams] = useSearchParams();
    const navigate = useNavigate();

    useEffect(() => {
        const message = searchParams.get('message');

        navigate('/');
        alert(message);
    });

    return null;
}

export default LoginErrorCallback;
